import { useState, useEffect } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Save } from "lucide-react";

export default function OperadorForm({ opId, schema }) {
  const { user } = useAuth();
  const canWrite = user?.role === "admin" || user?.role === "operador";
  const [info, setInfo] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let active = true;
    setInfo(null);
    api.get(`/operadores/${opId}`).then((res) => { if (active) setInfo(res.data.info || {}); });
    return () => { active = false; };
  }, [opId]);

  const set = (k, v) => setInfo((f) => ({ ...f, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/operadores/${opId}`, { data: info || {} });
      toast.success("Datos del operador guardados");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="operador-form">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-xl font-semibold tracking-tight text-slate-900" style={{ fontFamily: "Work Sans" }}>
            Datos del Operador
          </h2>
          <p className="text-sm text-muted-foreground">Ficha maestra (hoja OPERADOR del DDR)</p>
        </div>
        {canWrite && (
          <button
            onClick={save}
            disabled={saving}
            data-testid="save-operador"
            className="inline-flex items-center gap-2 rounded-md bg-primary text-primary-foreground h-9 px-4 text-sm font-medium shadow-sm hover:bg-primary/90 disabled:opacity-60"
          >
            <Save size={16} /> {saving ? "Guardando…" : "Guardar"}
          </button>
        )}
      </div>

      <div className="border border-border rounded-md shadow-sm bg-card p-6 grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl">
        {info === null ? (
          <p className="text-sm text-muted-foreground sm:col-span-2">Cargando…</p>
        ) : schema.columns.map((col) => (
          <div key={col.key} className={col.key === "nombre" || col.key === "direccion" ? "sm:col-span-2" : ""}>
            <label className="text-xs font-semibold uppercase tracking-wide text-slate-500">{col.label}</label>
            <input
              type={col.type === "number" ? "number" : "text"}
              value={info[col.key] ?? ""}
              onChange={(e) => set(col.key, e.target.value)}
              disabled={!canWrite}
              data-testid={`op-field-${col.key}`}
              className="mt-1 flex h-9 w-full rounded-md border border-input bg-card px-3 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary disabled:bg-slate-50 disabled:text-slate-500"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
